export enum EInputConstants {
  EmptyErrorText = '',
}

export enum EInputErrorTextConstant {
  Empty = 'введите номер',
  Incomplete = 'введите номер полностью',
  Beeline = 'номер не билайн',
}
